module.exports = __webpack_public_path__ + "static/three-business-owners-desktop.08665579.webp";